/* Cicabelle 2.0 — wishlist hearts (localStorage) + toast + custom-card
   Add-To-Bag. Capture-phase delegation so everything works on
   load-more-appended cards too. Locale-aware: routes and shopper-facing
   strings come from window.cb2I18n (rendered by snippets/cb-i18n.liquid). */
(function () {
  var KEY = 'cb2_wishlist';
  function i18n(k, fallback) {
    return (window.cb2I18n && window.cb2I18n[k]) || fallback;
  }
  function market() {
    var config = window.cbMarketConfig;
    return config && (config.country === 'SA' || config.country === 'KW') ? config : null;
  }
  function marketRoot(config) {
    var path = config.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return path.charAt(path.length - 1) === '/' ? path : path + '/';
  }
  function root() {
    var config = market();
    if (config) return marketRoot(config);
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function cartUrl() {
    return i18n('cartUrl', root() + 'cart');
  }

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); return true; }
    catch (e) { return false; }
  }

  function sync() {
    var list = load();
    var hearts = document.querySelectorAll('[data-cb2-wish]');
    for (var i = 0; i < hearts.length; i++) {
      var on = list.indexOf(hearts[i].getAttribute('data-cb2-wish')) > -1;
      hearts[i].classList.toggle('is-on', on);
      hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    // the old wishlist-app badge in the header becomes the live count
    var counts = document.querySelectorAll('.wishlist-h-count, .wishlist-total-count');
    for (var c = 0; c < counts.length; c++) counts[c].textContent = list.length;
  }

  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cb2-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1900);
  }

  // Add-To-Bag / Choose-Options on the custom cb2 cards.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var go = e.target.closest('[data-cb2-goto]');
    if (go) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = go.getAttribute('data-cb2-goto');
      return;
    }
    var add = e.target.closest('[data-cb2-add]');
    if (!add) return;
    e.preventDefault();
    e.stopPropagation();
    if (add.classList.contains('busy')) return;
    add.classList.add('busy');
    if (!add.dataset.cb2Label) add.dataset.cb2Label = add.textContent;
    add.textContent = i18n('adding', 'Adding…');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(add.getAttribute('data-cb2-add'), 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = cartUrl();
    }).catch(function () {
      add.classList.remove('busy');
      add.textContent = add.dataset.cb2Label;
      toast(i18n('addError', 'Could not add — try the product page'));
    });
  }, true);

  // Back-button from the cart restores this page from bfcache with the busy
  // state still applied — reset any stuck buttons.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var stuck = document.querySelectorAll('[data-cb2-add].busy');
    for (var i = 0; i < stuck.length; i++) {
      stuck[i].classList.remove('busy');
      if (stuck[i].dataset.cb2Label) stuck[i].textContent = stuck[i].dataset.cb2Label;
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cb2-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-cb2-wish');
    var list = load();
    var i = list.indexOf(handle);
    var removing = i > -1;
    if (removing) list.splice(i, 1);
    else list.push(handle);
    if (!save(list)) {
      toast(i18n('wishlistError', "Wishlist isn't available on this device"));
      return;
    }
    if (removing) {
      toast(i18n('wishlistRemoved', 'Removed from your wishlist'));
    } else {
      toast(i18n('wishlistSaved', 'Saved to your wishlist ♥'));
      btn.classList.add('pop');
      setTimeout(function () { btn.classList.remove('pop'); }, 400);
    }
    sync();
    if (window.__cb2WlRefresh) window.__cb2WlRefresh();
  }, true);

  // ---- wishlist sheet (Sephora-style) ----
  (function () {
    var sheet = null, itemsEl = null, emptyEl = null;
    var productCache = {};
    function wlEls() {
      sheet = document.getElementById('cb2-wl');
      itemsEl = document.getElementById('cb2-wl-items');
      emptyEl = document.getElementById('cb2-wl-empty');
      return !!(sheet && itemsEl && emptyEl);
    }
    function money(cents, config) {
      if (config) {
        if (config.country === 'KW') return window.cbKwd && typeof window.cbKwd.presentment === 'function' ? window.cbKwd.presentment(cents, config.currency) : '';
        return config.country === 'SA' && config.currency === 'SAR' && window.cbSaMoney ? window.cbSaMoney.text(cents) : '';
      }
      return 'AED ' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    }
    function renderRows() {
      if (!wlEls()) return;
      var list = load();
      emptyEl.hidden = list.length > 0;
      itemsEl.innerHTML = '';
      var I = window.cb2WlI18n || {};
      list.forEach(function (handle) {
        var row = document.createElement('div');
        row.className = 'wl-row';
        row.dataset.handle = handle;
        itemsEl.appendChild(row);
        var config = market();
        var identity = config ? JSON.stringify([config.country, marketRoot(config), config.currency, config.locale, handle]) : handle;
        var snapshot = config ? {country: config.country, currency: config.currency, locale: config.locale} : null;
        var ready = productCache[identity]
          ? Promise.resolve(productCache[identity])
          : fetch((config ? marketRoot(config) : '/') + 'products/' + encodeURIComponent(handle) + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (p) { productCache[identity] = p; return p; })
              .catch(function () { return null; });
        ready.then(function (p) {
          if (!p) { row.remove(); return; }
          var img = document.createElement('img');
          img.src = (p.featured_image || (p.images && p.images[0]) || '') + (p.featured_image ? '&width=180'.replace('&', p.featured_image.indexOf('?') > -1 ? '&' : '?') : '');
          img.alt = '';
          img.loading = 'lazy';
          var info = document.createElement('div');
          info.className = 'wl-info';
          var a = document.createElement('a');
          a.className = 'wl-title';
          a.href = p.url;
          a.textContent = p.title;
          var price = document.createElement('div');
          price.className = 'wl-price';
          price.textContent = money(p.price, snapshot);
          if (p.compare_at_price && p.compare_at_price > p.price) {
            var s = document.createElement('s');
            s.textContent = money(p.compare_at_price, snapshot);
            price.appendChild(s);
          }
          info.appendChild(a); info.appendChild(price);
          var actions = document.createElement('div');
          actions.className = 'wl-actions';
          if (p.variants && p.variants.length === 1 && p.available) {
            var add = document.createElement('button');
            add.type = 'button';
            add.className = 'wl-add';
            add.setAttribute('data-cb2-add', p.variants[0].id);
            add.textContent = (I.add || 'Add To Bag');
            actions.appendChild(add);
          } else {
            var view = document.createElement('a');
            view.className = 'wl-add';
            view.href = p.url;
            view.textContent = (I.view || 'View');
            actions.appendChild(view);
          }
          var rem = document.createElement('button');
          rem.type = 'button';
          rem.className = 'wl-remove';
          rem.setAttribute('data-cb2-wish', handle);
          rem.textContent = (I.remove || 'Remove');
          actions.appendChild(rem);
          row.appendChild(img); row.appendChild(info); row.appendChild(actions);
        });
      });
    }
    function openWl() {
      if (!wlEls()) return;
      renderRows();
      // signing in carries the on-device list to the account, where the
      // claim endpoint stores it permanently (hybrid wishlist)
      var signBtn = document.getElementById('cb2-wl-signin-btn');
      if (signBtn) {
        var lst = load().slice(0, 60);
        signBtn.href = 'https://account.cicabelle.com/login' + (lst.length ? '?wl=' + encodeURIComponent(lst.join(',')) : '');
      }
      document.documentElement.classList.add('cb2wl-open');
    }
    function closeWl() { document.documentElement.classList.remove('cb2wl-open'); }
    window.__cb2WlRefresh = function () {
      if (document.documentElement.classList.contains('cb2wl-open')) renderRows();
    };
    // the old wishlist-app header heart opens OUR sheet everywhere it appears
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var heart = e.target.closest('.h-wishlist-icon, .wishlist-page-widget, #cb2-wish-open');
      if (heart && !heart.hasAttribute('data-cb2-wish')) {
        e.preventDefault();
        e.stopPropagation();
        openWl();
        return;
      }
      if (e.target.closest('#cb2-wl-close') || (e.target.id === 'cb2-wl-overlay')) closeWl();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeWl(); });
  })();

  function arm() {
    sync();
    // the theme clones/rebuilds the header after load (sticky header) — the
    // fresh badge node is born with the server-rendered "0", so re-sync late
    window.addEventListener('load', function () { sync(); setTimeout(sync, 800); });
    var t = null;
    var mo = new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          var hit = (node.hasAttribute && node.hasAttribute('data-cb2-wish')) ||
            (node.classList && (node.classList.contains('wishlist-h-count') || node.classList.contains('wishlist-total-count'))) ||
            (node.querySelector && node.querySelector('[data-cb2-wish], .wishlist-h-count, .wishlist-total-count'));
          if (hit) {
            clearTimeout(t);
            t = setTimeout(sync, 150);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('collection:reloaded', function () { setTimeout(sync, 100); });
    // EVERY door into the account portal carries the on-device wishlist —
    // the portal claims it on any signed-in page, so the transfer no longer
    // depends on the one sheet sign-in button (an already-signed-in customer
    // never even sees /login).
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="https://account.cicabelle.com"]');
      if (!a) return;
      var list = load();
      if (!list.length) return;
      try {
        var u = new URL(a.href);
        if (!u.searchParams.get('wl')) u.searchParams.set('wl', list.slice(0, 60).join(','));
        a.href = u.toString();
      } catch (err) {}
    }, true);
  }

  if (document.readyState !== 'loading') arm();
  else document.addEventListener('DOMContentLoaded', arm);
})();

/* Glow points teaser (2026-09-29): "You'll earn ~N Glow points with this order",
   one small muted line in the cart totals area (above the checkout button) and
   in the PDP price area. N mirrors the ledger's accrual basis — 1 point per
   whole AED of the order's post-discount payable amount (the daily accrual
   floors the paid order total; the account app shows Math.round(order total),
   the admin reversal Math.floor(refunded AED)) — so on the cart N =
   floor(cart total_price / 100) (post-discount, pre-shipping: shipping is not
   known on the cart, hence the "~"), and on the PDP the current variant's
   price in whole AED. String via window.cb2I18n.glowPoints (cb-t glow_points,
   [count]; Western digits, as prices). Never a wrong number: no parseable
   amount, an empty cart or a 0 -> no line at all. Sits OUTSIDE the discount
   engine and the aligned-money display: it only ever writes its own
   .cb2-glow-note node. This block deliberately sits BEFORE the minimum-spend
   block: the min-spend / Enter / belt harnesses slice that file region by its
   header comments. */
(function () {
  'use strict';
  var tpl = window.cb2I18n && window.cb2I18n.glowPoints;
  if (!tpl || typeof tpl !== 'string' || typeof window.fetch !== 'function') return;
  if (/[%٪﹪％]/.test(tpl)) return; // belt: engine-adjacent UI never renders a percent sign
  function text(n) { return tpl.split('[count]').join(String(n)); }
  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function ensureCss() {
    if (document.getElementById('cb2-glow-css')) return;
    var s = document.createElement('style');
    s.id = 'cb2-glow-css';
    s.textContent = '.cb2-glow-note{font-family:Jost,system-ui,sans-serif;font-size:12px;line-height:1.5;color:#8a8f8a;margin:0 0 10px;text-align:start}' +
      '.product-block--price .cb2-glow-note{margin:6px 0 0}';
    (document.head || document.documentElement).appendChild(s);
  }
  // write-if-changed so our own mutation never re-triggers the observers below
  function put(parent, before, n) {
    var el = parent.querySelector('.cb2-glow-note');
    if (!(n > 0)) { if (el && el.parentNode) el.parentNode.removeChild(el); return; }
    if (!el) {
      ensureCss();
      el = document.createElement('p');
      el.className = 'cb2-glow-note';
      parent.insertBefore(el, before || null);
    }
    var s = text(n);
    if (el.textContent !== s) el.textContent = s;
  }
  /* cart page: N = the post-discount payable total, whole AED, floored */
  var t = null;
  function cartWrap() {
    var form = document.getElementById('CartPageForm');
    return form && form.querySelector('.cart__checkout-wrapper');
  }
  function cartRun() {
    t = null;
    if (!cartWrap()) return;
    window.fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var wrap = cartWrap();
        if (!wrap) return;
        var total = cart && Number(cart.total_price);
        var n = cart && cart.item_count > 0 && isFinite(total) ? Math.floor(total / 100) : 0;
        put(wrap, wrap.querySelector('.cart__checkout'), n);
      })
      .catch(function () {});
  }
  function kick() { clearTimeout(t); t = setTimeout(cartRun, 400); }
  /* PDP: N = the price on show (the current variant), whole AED, floored.
     theme.js rewrites [data-product-price] on variant change — observed. */
  var pt = null;
  function pdpBlock() {
    if (!document.body || !document.body.classList.contains('template-product')) return null;
    return document.querySelector('.product-block--price');
  }
  function pdpRun() {
    pt = null;
    var block = pdpBlock();
    var price = block && block.querySelector('[data-product-price]');
    if (!block) return;
    // first number in the money string ("AED 94.00", "Dhs. 1,234.50" — a
    // dotted currency prefix must not poison the parse), commas stripped
    var m = price ? String(price.textContent || '').match(/\d[\d,]*(?:\.\d+)?/) : null;
    var n = m ? Math.floor(parseFloat(m[0].replace(/,/g, ''))) : 0;
    put(block, null, isFinite(n) ? n : 0);
  }
  function pkick() { clearTimeout(pt); pt = setTimeout(pdpRun, 200); }
  function boot() {
    if (cartWrap()) {
      cartRun();
      ['cart:updated', 'cart:change', 'ajaxProduct:added', 'cart:build'].forEach(function (ev) {
        document.addEventListener(ev, kick);
      });
      if (typeof MutationObserver === 'function') {
        var subs = document.querySelectorAll('#CartPageForm [data-subtotal]');
        if (subs.length) {
          var mo = new MutationObserver(kick);
          for (var i = 0; i < subs.length; i++) mo.observe(subs[i], { childList: true, characterData: true, subtree: true });
        }
      }
      window.addEventListener('pageshow', function (e) { if (e.persisted) kick(); });
    }
    var block = pdpBlock();
    if (block) {
      pdpRun();
      if (typeof MutationObserver === 'function') {
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var el = muts[i].target && muts[i].target.nodeType === 1 ? muts[i].target : muts[i].target && muts[i].target.parentElement;
            if (el && el.closest && el.closest('.cb2-glow-note')) continue; // our own write
            pkick();
            return;
          }
        }).observe(block, { childList: true, characterData: true, subtree: true });
      }
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* Cart: minimum-spend message (owner decision 2026-09-26: "when I apply Cica30 to order value less than
   300, there should be an error message stating add more items to redeem this code ... similarly for any
   value based code"). Shopify keeps a code whose minimum is not met on the cart as applicable:false and
   says nothing. For EVERY such code the shopper holds, the cart page (under the code box) and the open
   drawer (above the checkout button) now say what is missing:
     "Add AED 50 more to use CICA30" / «أضيفي منتجات بقيمة 50 درهم لاستخدام الكود CICA30»;
     a minimum-QUANTITY code: "Add 1 more item to use X" (Arabic singular / dual / plural forms);
     a code limited to some products: "Spend AED 300 on eligible items to use X".
   Source: the Command Center's public code-info route (contract A, round 8: POST text/plain {code} ->
   {known:true, code, active, min_subtotal, min_quantity, scope "all"|"some", ends_at} | {known:false};
   never a value, a percentage or usage), cached per code (this tab 10 min; a failed call 60 s, memory).
   "Add X" = the code's minimum minus the cart's PRE-discount subtotal of its non-gift lines (scope "all"),
   whole AED rounded UP; nothing when that is already met (the code is off for another reason). Live: the
   cart is re-read (cart.js, debounced) on every cart re-render / cart event; the line goes once the code
   applies. Never for an applicable code, never for the engine's minted CB codes, never a percentage (the
   engine's four-sign belt). Independent of the discount engine: the same with its switch OFF (not loaded)
   and ON. Off the cart (no cart form, drawer closed): no request at all. theme.js's generic "Enter a valid
   discount code" notice is hidden while every code the cart holds but does not apply is explained here
   (every one: a sixth code past the five asked about is not, so the notice then stays — review round 8,
   finding 6). Known limit (review round 8, finding 3; the app's Bag does the same): an ORDER-class code's
   minimum (LED25) is measured by Shopify AFTER product discounts, so next to another applicable product code
   the true gap is a little larger than the line says; the line goes once the PRE-discount subtotal reaches
   the minimum, even if Shopify still does not apply the code (never a false "Add AED X": a product code
   blocked by a combination looks the same to the cart, and code-info does not say a code's class).
   Also: /ar parity for that notice (theme.js shows it after "?code=no" on the path "/cart" only), and
   (review round 8, finding 4) theme.js's Add reloads with "?code=no" for ANY code outside the theme's
   settings list — a valid code below its minimum too — so on that load the notice is held back
   (visibility) until the first answer: the line then takes its place, or — no line (an unknown code, a
   failed or slow route) — it shows as before, at the latest after WAIT_MS.
   Strings: window.cb2I18n.min* (snippets/cb-i18n.liquid, cb-t min_*). Harness:
   theme-build/tests/cb2-cart-minspend.harness.cjs. QA: cb2MinSpendDebug() / cb2MinSpendDebug.refresh(). */
(function () {
  'use strict';
  if (typeof window.fetch !== 'function' || typeof window.Promise !== 'function') return;
  var CI_URL = 'https://account.cicabelle.com/Admin-reports-Fahad/api/discount/code-info';
  var MINT_RE = /^CB[A-Z2-9]{10}$/;
  var PCT_RE = /[%٪﹪％]/;
  var KEY = 'cb2_ci', TTL = 10 * 60 * 1000, FAIL_TTL = 60 * 1000, CALL_MS = 6000, CART_MS = 6000;
  var DEBOUNCE = 500, MAX_CODES = 5, WAIT_MS = 4000;
  var FB = {
    minAdd: 'Add AED [amount] more to use [code]', minSome: 'Spend AED [amount] on eligible items to use [code]',
    minItem1: 'Add 1 more item to use [code]', minItem2: 'Add 2 more items to use [code]',
    minItemsFew: 'Add [count] more items to use [code]', minItemsMany: 'Add [count] more items to use [code]',
    minSomeItem1: 'Buy 1 eligible item to use [code]', minSomeItems: 'Buy [count] eligible items to use [code]'
  };
  var mem = {}, pend = {}, fail = {}, t = null, gen = 0, last = { codes: [], lines: [] }, holdT = null;
  function up(c) { return String(c == null ? '' : c).trim().toUpperCase(); }
  function num(x) { var n = Number(x); return x == null || x === '' || !isFinite(n) ? null : n; }
  function str(k) {
    var s = window.cb2I18n && window.cb2I18n[k];
    return String(typeof s === 'string' && s.trim() ? s : FB[k]).trim();
  }
  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function page() { return document.getElementById('CartPageForm'); }
  function drawerOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.classList.contains('drawer--is-open') && document.getElementById('CartDrawerForm'));
  }
  function active() { return !!page() || drawerOpen(); }
  // p's value, or null when it rejects or takes longer than ms
  function timed(p, ms) {
    return new Promise(function (resolve) {
      var x = setTimeout(function () { resolve(null); }, ms);
      p.then(function (v) { clearTimeout(x); resolve(v); }, function () { clearTimeout(x); resolve(null); });
    });
  }
  function ssAll() { try { return JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function cached(k) {
    var e = mem[k] || ssAll()[k];
    return e && e.v && Date.now() - e.t < TTL ? e.v : null;
  }
  function keep(k, v) {
    var e = { t: Date.now(), v: v }, all = ssAll(), out = {};
    mem[k] = e;
    all[k] = e;
    Object.keys(all).sort(function (a, b) { return all[b].t - all[a].t; }).slice(0, 20)
      .forEach(function (x) { out[x] = all[x]; });
    try { window.sessionStorage.setItem(KEY, JSON.stringify(out)); } catch (e2) {}
  }
  // contract A -> {known:false} | {known:true, active, minS, minQ, some, ends}; any other shape -> null
  function norm(b) {
    if (!b || typeof b !== 'object') return null;
    if (b.known === false) return { known: false };
    if (b.known !== true || typeof b.active !== 'boolean') return null;
    var ends = typeof b.ends_at === 'string' ? Date.parse(b.ends_at) : null;
    return { known: true, active: b.active, minS: num(b.min_subtotal), minQ: num(b.min_quantity),
      some: b.scope === 'some', ends: ends != null && isFinite(ends) ? ends : null };
  }
  // one code-info answer per code (joined while in flight); null = unknown (failure, timeout, bad shape)
  function info(code) {
    var k = up(code), c = cached(k);
    if (c) return Promise.resolve(c);
    if (fail[k] && Date.now() - fail[k] < FAIL_TTL) return Promise.resolve(null);
    if (pend[k]) return pend[k];
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ code: String(code).trim() }) };
    if (ctl) opts.signal = ctl.signal;
    var call = window.fetch(window.cb2CodeInfoUrl || CI_URL, opts).then(function (r) {
      if (!r || r.status !== 200) throw new Error('code-info ' + (r && r.status));
      return r.json();
    }).then(function (b) {
      var v = norm(b);
      if (!v) throw new Error('code-info shape');
      keep(k, v);
      return v;
    });
    var p = timed(call, CALL_MS).then(function (v) {
      if (!v) { fail[k] = Date.now(); if (ctl) { try { ctl.abort(); } catch (e) {} } }
      delete pend[k];
      return v;
    });
    pend[k] = p;
    return p;
  }
  function fill(k, map) {
    var s = str(k);
    ['amount', 'count', 'code'].forEach(function (x) { if (x in map) s = s.split('[' + x + ']').join(String(map[x])); });
    return s && !PCT_RE.test(s) ? s : null; // belt: never a percentage, whatever the string or the code carries
  }
  // The line for one code the cart holds but does not apply, or null (nothing to say, or not a minimum)
  function lineFor(code, v, cart) {
    if (!v || v.known !== true || v.active !== true) return null;
    if (v.ends != null && v.ends <= Date.now()) return null;
    var p = 0, units = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || (it.properties && it.properties._cb2_gift)) continue;
      p += Number(it.original_line_price) || 0;
      units += Number(it.quantity) || 0;
    }
    var name = up(code);
    if (v.minS != null && v.minS > 0) {
      if (v.some) return fill('minSome', { amount: v.minS % 1 === 0 ? String(v.minS) : v.minS.toFixed(2), code: name });
      var need = Math.round(v.minS * 100) - p;
      return need > 0 ? fill('minAdd', { amount: String(Math.ceil(need / 100)), code: name }) : null;
    }
    if (v.minQ != null && v.minQ > 0) {
      var q = Math.ceil(v.minQ);
      if (v.some) return q === 1 ? fill('minSomeItem1', { code: name }) : fill('minSomeItems', { count: q, code: name });
      var n = q - units;
      if (!(n > 0)) return null;
      return fill(n === 1 ? 'minItem1' : n === 2 ? 'minItem2' : n <= 10 ? 'minItemsFew' : 'minItemsMany', { count: n, code: name });
    }
    return null;
  }
  function ensureStyle() {
    if (document.getElementById('cb2-min-css')) return;
    var s = document.createElement('style');
    s.id = 'cb2-min-css';
    s.textContent = '.cb2-min-msgs{margin:8px 0 0}' +
      '.cb2-min-msg{font-family:Jost,system-ui,sans-serif;font-size:12.5px;line-height:1.5;color:#7a4b12;background:#fdf6ea;' +
      'border:1px solid #f0dcb9;border-radius:8px;padding:8px 12px;margin:0 0 6px;text-align:start}' +
      '.custom-discount-form.cb2-min-on p.error{display:none!important}' +
      '.custom-discount-form.cb2-min-wait p.error{visibility:hidden}';
    (document.head || document.documentElement).appendChild(s);
  }
  // Review round 8, finding 4: the load theme.js's Add reloaded with "?code=no" (the cart page only — the drawer
  // has no code box). The notice is held back while the first answer is on its way; release() lets it show
  // (the line, if any, is already in place and hides it); the hard stop WAIT_MS bounds the wait.
  function hold() {
    var cdf = page() && page().querySelector('.custom-discount-form');
    if (!cdf) return;
    ensureStyle();
    cdf.classList.add('cb2-min-wait');
    holdT = setTimeout(release, WAIT_MS);
  }
  function release() {
    if (holdT) { clearTimeout(holdT); holdT = null; }
    var els = document.querySelectorAll('.custom-discount-form.cb2-min-wait');
    for (var i = 0; i < els.length; i++) els[i].classList.remove('cb2-min-wait');
  }
  // lines on show in the cart page form (under the code box) and the drawer form (above checkout);
  // explained: every code the cart holds but does not apply has a line (theme.js's generic notice hides)
  function render(lines, explained) {
    var txt = lines.join('\n');
    var forms = [page(), document.getElementById('CartDrawerForm')];
    if (lines.length) ensureStyle();
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (!form) continue;
      var box = form.querySelector('.cb2-min-msgs'), cdf = form.querySelector('.custom-discount-form');
      if (cdf) cdf.classList.toggle('cb2-min-on', !!(lines.length && explained));
      if (!lines.length) { if (box && box.parentNode) box.parentNode.removeChild(box); continue; }
      if (!box) {
        var row = cdf && cdf.querySelector('.form'), anchor = form.querySelector('.cart__checkout-wrapper');
        var at = row && row.parentNode ? row.nextSibling : anchor;
        var parent = row && row.parentNode ? row.parentNode : anchor && anchor.parentNode;
        if (!parent) continue;
        box = document.createElement('div');
        box.className = 'cb2-min-msgs';
        box.setAttribute('role', 'status');
        box.setAttribute('aria-live', 'polite');
        parent.insertBefore(box, at);
      }
      if (box.getAttribute('data-k') === txt) continue;
      box.setAttribute('data-k', txt);
      while (box.firstChild) box.removeChild(box.firstChild);
      for (var j = 0; j < lines.length; j++) {
        var el = document.createElement('p');
        el.className = 'cb2-min-msg';
        el.textContent = lines[j];
        box.appendChild(el);
      }
    }
  }
  function run() {
    t = null;
    if (!active()) { release(); return; }
    var g = ++gen;
    timed(window.fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r || !r.ok) throw new Error('cart'); return r.json(); }), CART_MS).then(function (cart) {
      if (g !== gen) return null; // a newer run answers (and releases the held notice)
      if (!cart || !cart.items) { release(); return null; } // unknown cart: what is on show stays
      var codes = [], seen = {};
      (cart.discount_codes || []).forEach(function (d) {
        var c = d && d.code ? String(d.code).trim() : '';
        if (!c || d.applicable !== false || MINT_RE.test(up(c)) || seen[up(c)]) return;
        seen[up(c)] = 1;
        codes.push(c);
      });
      // every such code counts for "explained" — the ones past MAX_CODES are never asked about, so never explained
      var all = codes.length;
      codes = codes.slice(0, MAX_CODES);
      return Promise.all(codes.map(function (c) { return info(c).then(function (v) { return lineFor(c, v, cart); }); }))
        .then(function (ls) {
          if (g !== gen) return;
          var lines = ls.filter(Boolean);
          last = { codes: codes.map(up), lines: lines.slice() };
          render(lines, lines.length === all);
          release();
        });
    }).then(null, function () { if (g === gen) release(); });
  }
  function kick() { clearTimeout(t); t = setTimeout(run, DEBOUNCE); }
  // theme.js "?code=no" parity on /ar/cart (theme.js checks the path "/cart" only): the invalid-code
  // notice, unless a code tag is on show, and the parameter goes
  function arParity() {
    var p = window.location.pathname;
    if (p === '/cart' || !/\/cart\/?$/.test(p)) return;
    var u;
    try { u = new URL(window.location.href); } catch (e) { return; }
    if (u.searchParams.get('code') !== 'no') return;
    u.searchParams.delete('code');
    try { window.history.replaceState({}, document.title, u.pathname + u.search); } catch (e) {}
    var err = document.querySelector('.custom-discount-form p.error');
    if (err && !document.querySelector('.discounts__discount')) err.style.display = 'block';
  }
  function boot() {
    // before arParity / theme.js take "?code=no" off the address (this file is deferred: it runs before
    // DOMContentLoaded, where theme.js shows the notice on /cart)
    var no = false;
    try { no = /\/cart\/?$/.test(window.location.pathname) && new URL(window.location.href).searchParams.get('code') === 'no'; } catch (e) {}
    if (no) hold();
    arParity();
    if (typeof MutationObserver === 'function') {
      // theme.js cartMarkup (rows + subtotal), the engine's re-render, a gift added / removed
      var mo = new MutationObserver(kick);
      var els = document.querySelectorAll('#CartPageForm [data-products], #CartPageForm [data-subtotal], ' +
        '#CartDrawerForm [data-products], #CartDrawerForm [data-subtotal]');
      for (var i = 0; i < els.length; i++) mo.observe(els[i], { childList: true, characterData: true, subtree: true });
    }
    ['cart:updated', 'cart:change', 'ajaxProduct:added', 'cart:build', 'drawerOpen.CartDrawer', 'cart:open']
      .forEach(function (ev) { document.addEventListener(ev, kick); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) kick(); });
    if (active()) run();
  }
  window.cb2MinSpendDebug = function () { return { codes: last.codes.slice(), lines: last.lines.slice(), active: active() }; };
  window.cb2MinSpendDebug.refresh = function () {
    mem = {}; fail = {}; pend = {};
    try { window.sessionStorage.removeItem(KEY); } catch (e) {}
    run();
  };
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* Cart discount box: Enter = the Add button (2026-09-26). The code box of
   sections/main-cart.liquid (input[name="custom-discount-input"]#discount-code,
   Add = button[type=button]#apply-discount) sits INSIDE form#CartPageForm, so
   Enter in it submitted the cart form: the browser's implicit submission clicks
   the form's first submit button, the checkout button, and AVADA / the discount
   engine went to checkout WITHOUT the code (seen live on /cart and /ar/cart).
   Enter now does what Add does: it clicks the box's own Add button (theme.js's
   #apply-discount handler, no logic copied here) and never submits the form.
   An empty or blank box + Enter does nothing; a held Enter (key repeat) adds
   nothing. Window capture, delegated: it runs before any document-level
   listener and covers a re-rendered box; the engine and AVADA never see a
   checkout click from this box. Engine on or off: the same. IME: key "Process"
   passes untouched; an Enter the IME processed (keyCode 229: the Enter that
   commits a composition in Chrome/Edge, or follows compositionend in Safari)
   is cancelled but never applies a half-typed code. Known limit: this file is
   deferred, so an Enter pressed before it has run (page visible, scripts still
   loading; theme.js's Add handler does not exist yet either) still submits the
   cart form, as before. The box's form owner is deliberately left alone:
   detaching it (form="...") may change the mobile keyboard's Go/Next key. */
(function () {
  var BOX = 'input[name="custom-discount-input"],#discount-code';
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var t = e.target;
    try { if (!t || !t.matches || !t.matches(BOX)) return; } catch (x) { return; }
    e.preventDefault(); // no implicit submission: this box never starts a checkout
    if (e.repeat || e.keyCode === 229 || !String(t.value || '').trim()) return;
    var box = t.closest('.custom-discount-form,.cart-discount') || t.parentNode;
    var add = (box && box.querySelector('#apply-discount,.submit-discount')) || document.getElementById('apply-discount');
    if (add && !add.disabled) add.click();
  }, true);
})();

/* Cart-offers discount auto-apply (sitewide belt for drawer->checkout paths;
   the cart-page rail JS does the same, and owns it on the cart page). Once the
   eligible subtotal (excluding free-gift lines) crosses the configured
   threshold, the unlock code goes ON THE CART: POST /cart/update.js {discount:
   every own code already on the cart, in its order, then the unlock code} — the
   parameter REPLACES the list, so no code is dropped. (Live incident
   2026-10-01: the old background GET /discount/CODE only set Shopify's discount
   cookie — cart.js kept no code, the discount engine never priced cica30 and
   checkout took its bare 2% floor. No cookie any more: it would put back at
   checkout a code the engine or the shopper took off the cart.) The code's own
   store-side minimum spend is the real guard. Config from cb-i18n.liquid.
   Discount engine ON (window.cb2Engine mode "on"): only while the cart has NO
   other code — next to the shopper's own code, at AED 300+ the non-combinable
   unlock code displaces it (the affiliate loses the order, the engine
   disengages). Same rule as the cart rail (snippets/cb-cart-offers-rail.liquid)
   and the iOS app. Switch off: next to every own code, as today. Never over a
   minted top-up (CB + 10: the engine's), never when the code is already on the
   cart; once per session ('cb2_disc_' + code, set when the write is answered); a
   failed write is tried once more on the next cart event. An open drawer's prices
   follow through theme.js's own re-render (cart:build). */
(function () {
  var cfg = window.cb2Offers;
  if (!cfg || !cfg.code || !cfg.thr) return;
  var t = null, tries = 0;
  var dk = 'cb2_disc_' + cfg.code;
  var seen = function () { try { return !!sessionStorage.getItem(dk); } catch (e) { return false; } };
  var check = function () {
    if (seen() || tries >= 2) return;
    // the cart page: the rail's script runs there (its gift gate holds checkout while it writes)
    if (window.__cb2CartOffers && document.getElementById('cb2-offers-rail')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = 0;
        (cart.items || []).forEach(function (i) {
          if (i.properties && i.properties._cb2_gift) gifts += i.original_line_price;
        });
        // pre-discount subtotal: the threshold is a spend target, and the
        // applied code itself lowers total_price below it
        if (cart.original_total_price - gifts < cfg.thr) return;
        if (seen()) return; // applied meanwhile (another tab, the rail)
        var codes = (cart.discount_codes || []).filter(function (d) { return d && d.code; });
        if (codes.some(function (d) {
          var u = String(d.code).trim();
          return u.toLowerCase() === String(cfg.code).toLowerCase() || /^CB[A-Z2-9]{10}$/.test(u.toUpperCase());
        })) return;
        var eng = window.cb2Engine;
        if (eng && eng.mode === 'on' && codes.length) return;
        tries++;
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.map(function (d) { return String(d.code); }).concat([String(cfg.code)]).join(',') }) })
          .then(function (r) {
            if (!r.ok) return;
            try { sessionStorage.setItem(dk, '1'); } catch (e) {}
            if (document.getElementById('CartDrawerForm')) {
              try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
            }
          });
      })
      .catch(function () {});
  };
  var kick = function () { clearTimeout(t); t = setTimeout(check, 900); };
  if (document.readyState !== 'loading') kick();
  else document.addEventListener('DOMContentLoaded', kick);
  ['cart:updated', 'cart:change', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, kick);
  });
  window.addEventListener('pageshow', kick);
})();
